import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';


Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        backgroundColor: "#FFFFFF",
        primary: "#0FA2DF",
        primaryText: "#3E4A59",
        secondaryText: "#3E4A59",
        accent: "#0FA2DF"
      }
    }
  },
  icons: {
    iconfont: 'mdi',
  },
});